<template>
  <div class="w3-container">
    <!-- 登录表单卡片 -->
    <div class="w3-card w3-margin-top" style="max-width: 500px; margin: 0 auto">
      <div class="w3-container w3-green">
        <h2>登录</h2>
      </div>

      <!-- 登录表单 -->
      <form @submit.prevent="login" class="w3-container w3-padding-16">
        <!-- 用户名输入 -->
        <div class="w3-section">
          <label class="w3-text-green"><b>用户名</b></label>
          <input
            type="text"
            class="w3-input w3-border"
            v-model="username"
            placeholder="请输入用户名"
            requigreen
          >
        </div>

        <!-- 密码输入 -->
        <div class="w3-section">
          <label class="w3-text-green"><b>密码</b></label>
          <input
            type="password"
            class="w3-input w3-border"
            v-model="password"
            placeholder="请输入密码"
            requigreen
          >
        </div>


        <!-- 提交按钮 -->
        <div class="w3-section">
          <button type="submit" class="w3-button w3-green w3-block">
            立即登录
          </button>
        </div>

        <!-- 提示消息 -->
        <div v-if="message" :class="messageClass">
          <p>{{ message }}</p>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import SHA256 from 'crypto-js/sha256';

export default {
  data() {
    return {
      username: '',
      password: '',
      message: '',
      isSuccess: false // 标记是否成功
    };
  },
  created() {
    const query = this.$route.query;
    if(query.err) {
      this.message = "用户名或密码错误";
    }

  },
  computed: {
    messageClass() {
      return this.isSuccess 
        ? 'w3-panel w3-green w3-round' 
        : 'w3-panel w3-red w3-round';
    }
  },
  methods: {
    login() {
      // 清除之前的消息
      this.message = '';
      this.isSuccess = false;
      // 检查用户名和密码是否为空
      if (!this.username || !this.password) {
        this.message = '用户名和密码不能为空';
        this.isSuccess = false;
        return;
      }
      const passHash = SHA256(this.password).toString();
      sessionStorage.setItem('agentName', this.username);
      sessionStorage.setItem('agentPass', passHash);
      this.$router.push('/agentInfo');
    }
  }
};
</script>

<style scoped>
/* 可选：自定义补充样式 */
.w3-card {
  margin-top: 30px;
}

.w3-input {
  margin-top: 5px;
}
</style>